import { readPointAchieveList, readPointStakeSettingList } from '@/api/point/read';
import { ChangeEvent, Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2';
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { AddIndexResReadPointStakeListType, ResReadPointStakeListType } from '@/types';
import { compareArrays } from '@/lib/Compare';
import { updatePointStake } from '@/api/point/update';
import { sleep } from '@/lib/util';
import Loading from '@/component/mui/Backdrop';
import { toast } from 'react-toastify';
import { now, nowSubtractToISOString } from '@/lib/dayjs';
// 리스트 완료 생성부분 마져하면 됨
export default function PointSettingStakeList({ settingId, refresh }: { settingId: string; refresh: number }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState<AddIndexResReadPointStakeListType[] | []>([]);
  const [oldList, setOldList] = useState<AddIndexResReadPointStakeListType[] | []>(list);

  useEffect(() => {
    if (!settingId) {
      navigate('/point-setting-list');
    }

    return () => {};
  }, [settingId, navigate]);

  useEffect(() => {
    (async () => {
      const re = await readPointStakeSettingList(settingId);
      console.log(re);
      if (re.status !== 200) {
        return;
      }
      const list: AddIndexResReadPointStakeListType[] = re.data.map(
        (item: ResReadPointStakeListType, index: number) => {
          return {
            index: index,
            ...item,
            startDt: now(item.startDt),
            utcStartDt: nowSubtractToISOString(item.startDt),
            endDt: now(item.endDt),
            utcEndDt: nowSubtractToISOString(item.endDt),
          };
        },
      );
      setList(list);
      setOldList(list);
    })();
    return () => {};
  }, [refresh]);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
    const { name, value } = e.target;
    if (!name) {
      return;
    }
    if (!list || !oldList) {
      return;
    }
    setList((prev) =>
      prev
        ? prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  [name]: value,
                }
              : item,
          )
        : prev,
    );
  };
  const onSubmitUpdate = async () => {
    if (!list || !oldList) {
      return;
    }
    setIsLoading(true);
    const datas = compareArrays(list, oldList); // .filter((item) => Object.keys(item).length > 0);
    if (!datas) {
      return;
    }

    let arr = [];
    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      if (Object.keys(datas[i]).length > 0) {
        const temp = {
          seasonId: element.seasonId,
          ...datas[i],
        };
        arr.push(temp);
      }
    }
    const failedList = [];
    for (const iter of arr) {
      try {
        await updatePointStake(iter);
        await sleep(1000);
      } catch (e) {
        failedList.push(iter);
      }
    }
    setIsLoading(false);
    if (failedList.length > 0) {
      toast.error(`${failedList.length}건 실패하였습니다.`);
    } else {
      toast.success('성공');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      {/* {list[0] && (
        <>
          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <Typography variant="h6">season: {list[0].season}</Typography>
            </Grid>
            <Grid xs={6}>
              <Typography variant="h6">code: {list[0].code}</Typography>
            </Grid>
          </Grid>
        </>
      )} */}

      <Divider />
      <Box mb={3} />
      {list.length > 0 && (
        <>
          {list.map((item: AddIndexResReadPointStakeListType) => (
            <Fragment key={item.index}>
              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <Typography variant="h6">No.{item.index}</Typography>
                </Grid>
                {/* <Grid xs={6}>
                  <Button onClick={() => onSubmitUpdate()}>변경</Button>
                </Grid> */}
              </Grid>

              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>Title</InputLabel>
                    <OutlinedInput
                      value={item.title}
                      label="title"
                      name="title"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                  </FormControl>
                </Grid>

                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>이자 (%)</InputLabel>
                    <OutlinedInput
                      value={item.interestRate}
                      label="interestRate"
                      name="interestRate"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Box mb={2} />
              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>시작날짜</InputLabel>
                    <OutlinedInput
                      type="string"
                      value={item.startDt}
                      label="startDt"
                      name="startDt"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                    <FormHelperText>※ kst 입력해야 utc로 저장됨, utc: {item.utcStartDt}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>종료 날짜</InputLabel>
                    <OutlinedInput
                      type="string"
                      value={item.endDt}
                      label="endDt"
                      name="endDt"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                    <FormHelperText>※ kst 입력해야 utc로 저장됨, utc: {item.utcEndDt}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Box mb={5} />
              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>리워드 지급일</InputLabel>
                    <OutlinedInput
                      type="string"
                      value={item.rewardDt}
                      label="rewardDt"
                      name="rewardDt"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                  </FormControl>
                </Grid>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>usdt</InputLabel>
                    <OutlinedInput
                      type="string"
                      value={item.usdt}
                      label="usdt"
                      name="usdt"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Box mb={5} />
              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>목표 포인트</InputLabel>
                    <OutlinedInput
                      type="string"
                      value={item.requireAmount}
                      label="requireAmount"
                      name="requireAmount"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                  </FormControl>
                </Grid>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>season_id</InputLabel>
                    <OutlinedInput
                      disabled
                      type="string"
                      value={item.seasonId}
                      label="seasonId"
                      name="seasonId"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Divider />
              <Box mb={5} />
            </Fragment>
          ))}
          <Button variant="outlined" fullWidth onClick={onSubmitUpdate}>
            변경
          </Button>
        </>
      )}
      <Loading isLoading={isLoading} />
    </Box>
  );
}

/**
 * 등록, 리스트
 *
 * 등록 할 때 멘트도 함께 나오게 해야 한다
 *
 * 화면 구성은??
 * 수량, usdt, 설명1, 설명2
 *
 */
